import React, { Component } from 'react'

import Button from '../../../../SPRINTA/atoms/Button'
import Create from '../Create'

import T from '../../../../SPRINTA/translate/T'
import FontIcon from '../../../Components/Atom/FontIcon'
import { Text  } from '../../../../SPRINTA/atoms/Forms'
import Loading from '../../../../SPRINTA/atoms/Loading'
import * as event from '../../../Utils/event'
import { Col, Row } from '../../../../SPRINTA/atoms/Grid'

import { dateFormat } from '../../../../SPRINTA/helpers/Formatter'

import style from './style.css'

export default class Copy extends Component {

    state = {
        form: {
            searchEvent: ''
        },
        loading: true,
        events: [],
        cloning: null,
        event: null
    }

    searchEvents() {
        this.setState({
            loading: true
        })

        event.find(`order=desc&situation[0]=3&orderBy=date&title=${this.state.form.searchEvent}`)
        .then(data => {
           let events = []
           if(data.result && data.result.list)
            events = data.result.list

            this.setState({
                events,
                loading: false
            })
        })
    }

    componentWillMount() {
        this.searchEvents()
    }

    cloneEvent( id ) {
        this.setState({
            cloning: id
        })

        event.copy(id)
        .then(data => {
            this.setState({
                event: data.eventId
            })
        })
    }

    render() {

        if(this.state.event) {
            return (
                <Create scrollToStart={() => this.props.scrollToStart()} handleFinished={this.props.handleFinished} event={this.state.event} />
            )
        }

        return (
            <div className={style.criarWrap} style={{ float: 'left' }}>
                <div className={style.criar}>
                    <h1 style={{marginBottom: '20px'}}>{T.text('create_your_event_page_copy_title')}</h1>
                    <form onSubmit={(e) => {
                        e.preventDefault()
                        this.searchEvents()
                    }} style={{ marginBottom: '30px', float: 'left', width: '100%' }}>
                        <Text
                            ref={obj => { if(obj) { this.searchEvent = obj.refs.input }}}
                            iconRight={
                                <span style={{cursor: 'pointer'}}>
                                    <FontIcon name="search" color="#ff5500" size={14} />
                                </span>
                            }
                            placeholder={T.txt('find_a_event_created_by_you')}
                            handleChange={e =>
                                this.setState({
                                    form: {
                                        ...this.state.form,
                                        searchEvent: e.target.value
                                    }
                                })
                            }
                            value={this.state.form.searchEvent}
                        />
                        <input type='submit' style={{ display:'none' }} />
                    </form>

                    { this.state.loading ?
                        <div style={{
                                        marginTop: '30px',
                                        float: 'left',
                                        width: '100%',
                                        margin: '20px 0'
                                    }}>
                            <Loading />
                        </div>
                    :
                        <div style={{ float: 'left', width: '100%'}}>
                            {this.state.events.map( event =>
                                <div key={event.id} className={style.copydata} style={{
                                    float: 'left',
                                    width: '100%'
                                }}>

                                    <Row>
                                        <Col size='12 9'>
                                            <div className={style.date}>
                                                {dateFormat(T.txt('date_format_simple'), event.startDate)}
                                            </div>

                                            <h2 style={{ textAlign: 'left', marginTop: 0 }}>
                                                {event.title !== ''
                                                    ? event.title
                                                    : T.txt('event_without_title')
                                                }
                                            </h2>
                                        </Col>

                                        <Col size='12 3'>
                                            <Button style={{float: 'right', marginBottom: '10px'}} onClick={() => {
                                                this.cloneEvent(event.id)
                                            }} disabled={this.state.cloning} inline theme='primary'>
                                                {this.state.cloning === event.id ? (
                                                    <Loading size={22} color='#fff' />
                                                ) : (
                                                    T.text('create_your_event_page_copy_duplicate_button')
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>

                                </div>
                            )}

                        </div>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/pages/CreateEvent/Copy/index.js